import React from "react";
import { DateFormatter } from "../lib/components/Formatters";
import CustomAutoCompleteFilter from "../lib/components/customdatagridfilter/CustomFilter";
import { format } from "date-fns";

const cellWidthSmall = 70;
const cellWidthMedium = 140;
const cellWidthMediumX = 110;
const cellWidthLarge = 220;

const defaultColumnProperties = {
    resizable: true,
    sortable: true,
};

let currentSpace = true;

export const SailingScheduleColumns = (
    data = [],
    filters = {},
    arrangement = [],
    columnsWidth = {},
    vesseloptions = [],
    portoptions = [],
    shippinglines = [],
    additionalColumns = []
) => {
    let postValue = "";

    if (data && data.length > 0) {
        if (currentSpace) {
            postValue = " ";
        }
        currentSpace = !currentSpace;
    }

    const columns = [
        {
            key: "market",
            name: "Market" + postValue,
            width: cellWidthSmall,
            filterRenderer: (e) => {
                return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"market"} data={data} section="sailingschedule" />;
            }
        },
        {
            key: "etd",
            name: "ETD" + postValue,
            width: cellWidthMediumX,
            formatter: ({ row }) => <span>{row.etd || ""}</span>,
            filterRenderer: (e) => {
                return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"etd"} data={data} section="sailingschedule" />;
            }
        },
        {
            key: "port_of_loading",
            name: "Port of Loading" + postValue,
            width: cellWidthMedium,
            filterRenderer: (e) => {
                return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"port_of_loading"} data={data} section="sailingschedule" />;
            }
        },
        {
            key: "vessel",
            name: "Vessel" + postValue,
            width: cellWidthMedium,
            filterRenderer: (e) => {
                return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"vessel"} data={data} section="sailingschedule" />;
            }
        },
        {
            key: "voyage",
            name: "Voyage" + postValue,
            width: cellWidthSmall,
            filterRenderer: (e) => {
                return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"voyage"} data={data} section="sailingschedule" />;
            }
        },
        {
            key: "line",
            name: "Line" + postValue,
            width: cellWidthSmall,
            filterRenderer: (e) => {
                return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"line"} data={data} section="sailingschedule" />;
            }
        },
        {
            key: "line_service",
            name: "Line Service" + postValue,
            width: cellWidthMedium,
            filterRenderer: (e) => {
                return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"line_service"} data={data} section="sailingschedule" />;
            }
        },
        {
            key: "stacks",
            name: "Stacks" + postValue,
            width: cellWidthLarge,
            filterRenderer: (e) => {
                return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"stacks"} data={data} section="sailingschedule" />;
            }
        },
    ].map((c) => ({ ...c, ...defaultColumnProperties }));

    let allColumns = [...columns, ...additionalColumns];

    let columnsArranged = [...allColumns];

    return columnsArranged;
};
